import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  changeType,
  clearFilter,
  search,
} from '../../features/filter/filterSlice';

const Header = () => {
  //   const [searchItem, setSearchItem] = useState('');

  const dispatch = useDispatch();
  const handleSearch = (e) => {
    dispatch(search(e.target.value));
  };
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);
    };
  };

  const handleDebounce = useCallback(debounce(handleSearch), []);

  const handleType = (e) => {
    dispatch(changeType(e.target.value));
  };
  const handleClear = () => {
    dispatch(clearFilter());
  };
  return (
    <div className="header">
      <input
        style={{ border: 'none', paddingInline: '30px', paddingBlock: '10px' }}
        onChange={handleDebounce}
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
      />

      <div
        style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
      >
        <div
          onClick={handleClear}
          style={{ marginInline: '20px' }}
          className="radio_group"
        >
          <input type="radio" name="type" />
          <label>All</label>
        </div>
        <div style={{ marginInline: '20px' }} className="radio_group">
          <input
            onClick={handleType}
            required
            type="radio"
            value="income"
            name="type"
          />
          <label>Income</label>
        </div>
        <div className="radio_group">
          <input
            onClick={handleType}
            type="radio"
            value="expense"
            name="type"
            placeholder="Expense"
          />
          <label>Expense</label>
        </div>
      </div>
    </div>
  );
};

export default Header;
